import React, { createContext, type ReactNode, useContext, useState } from 'react';

interface DownloadContextProps {
  isDownloading: boolean;
  setDownloading: (downloading: boolean) => void;
}

const DownloadContext = createContext<DownloadContextProps | undefined>(undefined);

export const useDownloadContext = (): DownloadContextProps => {
  const context = useContext(DownloadContext);
  if (!context) {
    throw new Error('useDownloadContext must be used within a DownloadProvider');
  }
  return context;
};

export const DownloadProvider = ({ children }: { children: ReactNode }): ReactNode => {
  const [isDownloading, setIsDownloading] = useState(false);

  return (
    <DownloadContext.Provider value={{ isDownloading, setDownloading: setIsDownloading }}>
      {children}
    </DownloadContext.Provider>
  );
};
